import { ArrowLeft } from "lucide-react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import AdvisoryEditor, {
  type AdvisoryEditorSubmit,
} from "../components/AdvisoryEditor";
import { apiService, extractApiError } from "../services/api";

export default function CreateSecurityAdvisoryPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMutation = useMutation(
    (payload: AdvisoryEditorSubmit) =>
      apiService.createSecurityAdvisory(payload),
    {
      onSuccess: () => {
        toast.success("Security advisory saved");
        queryClient.invalidateQueries(["security-advisories"]);
        navigate("/security-advisories");
      },
      onError: (error: unknown) => {
        toast.error(extractApiError(error, "Failed to save security advisory"));
      },
    },
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={() => navigate("/security-advisories")}
          className="text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Create advisory
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Author a CSAF 2.0 advisory with a guided form or raw JSON, then
            export CSAF and a Sandvik-branded PDF.
          </p>
        </div>
      </div>

      <AdvisoryEditor
        mode="create"
        submitting={createMutation.isLoading}
        onSubmit={(payload) => createMutation.mutate(payload)}
      />
    </div>
  );
}
